let visibleModals = 0;

class NanoModal {
  // constructor modal ID, config as object: config = {closeOnEscape: true, debug: false, closeOnOutsideClick: true, onClose: function(){}, onShow: function(){}}
  constructor(modal, config = {}) {
    // allow modal as string or element
    if (typeof modal === "string") {
      modal = document.querySelector(modal);
    }

    //this.modal = modal
    const defaultConfig = {
      closeOnEscape: true,
      debug: false,
      disableScroll: true,
      disableScrollShift: true,
      closeOnOutsideClick: true,
      onClose: null,
      onShow: null,
      backdropSelector: "[data-modal-backdrop]",
      modalContentSelector: "[data-modal-content]",
    };
    this.config = { ...defaultConfig, ...config };

    // log errors only when debug mode is true
    if (!modal && this.config.debug) {
      console.error("NanoModal: No modal element found");
      return;
    }

    this.modal = modal;
    this.init();
  }

  showModal(tooltip = false) {
    if (this.config.disableScroll) visibleModals += 1;
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 200);
    tooltip ? this.modal.show() : this.modal.showModal();
    this.modal.scrollTo(0, 0);
    this.config.onShow && this.config.onShow(this.modal);
    this.modal.classList.add("is-visible");

    document.activeElement.blur();

    // disable page scroll
    if (this.config.disableScroll && !this.config.disableScrollShift) {
      this.calculateScrollbarWidth();
    }
    if (this.config.disableScroll) {
      document.body.style.overflow = "hidden";
    }
  }

  toggleModal(tooltip = false) {
    this.modal.open ? this.hideModal() : this.showModal(tooltip);
  }

  hideModal() {
    if (this.config.disableScroll && visibleModals > 0) visibleModals -= 1;

    const hideModal = () => {
      this.modal.close();
      this.modal.classList.remove("is-visible");

      // enable page scroll
      if (visibleModals === 0 && this.config.disableScroll) {
        document.body.style.overflow = "auto";
        if (!this.config.disableScrollShift) {
          document.documentElement.style.marginRight = "";
        }
      }
    };

    let autoHide = true;
    if (this.config.onClose) {
      autoHide = this.config.onClose(this.modal, hideModal);
    }
    if (autoHide !== false) {
      hideModal();
    }
  }

  calculateScrollbarWidth() {
    const scrollBarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.marginRight = scrollBarWidth + "px";
  }

  closeOnOutsideClick() {
    // native backdrop
    this.modal.addEventListener("click", (event) => {
      let rect = this.modal.getBoundingClientRect();
      if (
        rect.left > event.clientX ||
        rect.right < event.clientX ||
        rect.top > event.clientY ||
        rect.bottom < event.clientY
      ) {
        this.hideModal();
      }
    });

    // custom backdrop
    const backdrop = this.modal.querySelector(this.config.backdropSelector);
    const modalContent = this.modal.querySelector(
      this.config.modalContentSelector
    );

    if (backdrop) {
      // console.log(backdrop);
      backdrop.addEventListener("click", (event) => {
        event.stopPropagation();
        // if click is outside of modal content
        // console.log("backdrop click");
        if (modalContent && !modalContent.contains(event.target)) {
          this.hideModal();
        }
      });
    }
  }

  init() {
    // close on escape
    this.modal.addEventListener("cancel", (event) => {
      event.preventDefault();
      if (this.config.closeOnEscape) {
        this.hideModal();
      }
    });

    const closeButtons = this.modal.querySelectorAll("[data-modal-close]");
    closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.hideModal();
      });
    });

    // close on outside click (on backdrop)
    if (this.config.closeOnOutsideClick) {
      this.closeOnOutsideClick();
    }
  }
}

export default NanoModal;

if (typeof window !== "undefined") {
  window.NanoModal = NanoModal;
}
